import httpResource from "@/components/infrastructures/functions/http/httpResource";

export default class SoundEsthePurposeService {

    public static async fetchPurposeDetails(purposeCode: string) {
        return httpResource.get(`/soundesthe/purpose-details?code=${purposeCode}`);
    }
}